// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hyfjQDTNMmm9hDTIAMfTi","groupsList":"eP-eayScIvDYP3hzqMoeI"};